import { render, staticRenderFns } from "./StarvationSpecies.vue?vue&type=template&id=2e1dfa95&scoped=true&"
import script from "./StarvationSpecies.vue?vue&type=script&lang=js&"
export * from "./StarvationSpecies.vue?vue&type=script&lang=js&"
import style0 from "./StarvationSpecies.vue?vue&type=style&index=0&id=2e1dfa95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1dfa95",
  null
  
)

export default component.exports